import type { ReactNode } from 'react';

type ContentRow = { key: string; bold?: boolean };
type AccordionSection = {
  titleKey: string;
  content: ContentRow[][];
};

const SECTIONS: AccordionSection[] = [
  {
    titleKey: 'Model',
    content: [[{ key: 'Ultrahuman Photon' }]],
  },
  {
    titleKey: 'Body',
    content: [
      [
        { key: 'Dimensions', bold: true },
        { key: '14.5 × 9.5 × 3.7 cm (5.75 × 3.78 in)' },
      ],
      [
        { key: 'Weight', bold: true },
        { key: '600g' },
      ],
      [
        { key: 'Finish', bold: true },
        { key: 'White matte body' },
      ],
    ],
  },
  {
    titleKey: 'Optical',
    content: [
      [
        { key: 'Wavelengths', bold: true },
        { key: '660nm Red (±10nm) and 850nm Near-Infrared (±10nm)' },
      ],
      [
        { key: 'LEDs', bold: true },
        { key: '12 dual-chip LEDs (red + NIR)' },
      ],
      [
        { key: 'Irradiance', bold: true },
        { key: '>100 mW/cm²' },
      ],
      [
        { key: 'Power Output', bold: true },
        { key: '48W' },
      ],
    ],
  },
  {
    titleKey: 'Battery',
    content: [
      [
        { key: 'Capacity', bold: true },
        { key: '6,000 mAh' },
      ],
      [
        { key: 'Sessions per Charge', bold: true },
        {
          key: 'Multiple 10-minute sessions per charge, with 10-minute auto-shutoff',
        },
      ],
      [
        { key: 'Charging', bold: true },
        { key: 'USB-C, 5V/1A. Approximately 3 to 4 hours to full charge.' },
      ],
    ],
  },
  {
    titleKey: 'Power Adapter',
    content: [
      [
        { key: 'Input Range', bold: true },
        { key: '100 to 240V (universal)' },
      ],
      [
        { key: 'Output', bold: true },
        { key: '5V, 3A' },
      ],
      [
        { key: 'Type', bold: true },
        { key: '3-in-1 universal (US / EU / UK prongs)' },
      ],
    ],
  },
];

const resolveSections = (
  sections: AccordionSection[],
): Array<{ title: ReactNode; content: ReactNode }> =>
  sections.map((section) => ({
    title: section.titleKey,
    content: (
      <>
        {section.content.map((block, blockIdx) => (
          <div key={blockIdx} className="content">
            {block.map((row, rowIdx) => (
              <div key={rowIdx} className="content-row">
                {row.bold ? (
                  <span className="bold">{row.key}</span>
                ) : (
                  <span>{row.key}</span>
                )}
              </div>
            ))}
          </div>
        ))}
      </>
    ),
  }));

export const photonTechSpecsImages = [
  {
    src: 'web_v2/photon/tech-specs/spec-white.png',
    alt: 'Photon LED panel',
    textBold: 'Twelve LEDs.',
    textNormal: 'Surface healing and deep tissue recovery, in a single panel.',
  },
  {
    src: 'web_v2/photon/tech-specs/spec-black.png',
    alt: 'Photon dual-wavelength LEDs',
    textBold: 'Dual-wavelength.',
    textNormal: 'Every LED emits both 660nm and 850nm, simultaneously.',
  },
];

export const photonTechSpecsAccordionItems = resolveSections(SECTIONS);
